/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { mapValues } from '../runtime';
import { UnitEconomicsTierRowFromJSON, UnitEconomicsTierRowToJSON } from './UnitEconomicsTierRow';
import { UnitEconomicsUserRowFromJSON, UnitEconomicsUserRowToJSON } from './UnitEconomicsUserRow';
/**
 * Check if a given object implements the UnitEconomicsResponse interface.
 */
export function instanceOfUnitEconomicsResponse(value) {
    if (!('costByTier' in value) || value['costByTier'] === undefined)
        return false;
    if (!('days' in value) || value['days'] === undefined)
        return false;
    if (!('freeTierBurnUsd' in value) || value['freeTierBurnUsd'] === undefined)
        return false;
    if (!('hoursSinceLastEventEver' in value) || value['hoursSinceLastEventEver'] === undefined)
        return false;
    if (!('topUsers' in value) || value['topUsers'] === undefined)
        return false;
    return true;
}
export function UnitEconomicsResponseFromJSON(json) {
    return UnitEconomicsResponseFromJSONTyped(json, false);
}
export function UnitEconomicsResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'costByTier': (mapValues(json['costByTier'], UnitEconomicsTierRowFromJSON)),
        'days': json['days'],
        'freeTierBurnUsd': json['freeTierBurnUsd'],
        'hoursSinceLastEventEver': json['hoursSinceLastEventEver'],
        'topUsers': (json['topUsers'].map(UnitEconomicsUserRowFromJSON)),
    };
}
export function UnitEconomicsResponseToJSON(json) {
    return UnitEconomicsResponseToJSONTyped(json, false);
}
export function UnitEconomicsResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'costByTier': (mapValues(value['costByTier'], UnitEconomicsTierRowToJSON)),
        'days': value['days'],
        'freeTierBurnUsd': value['freeTierBurnUsd'],
        'hoursSinceLastEventEver': value['hoursSinceLastEventEver'],
        'topUsers': (value['topUsers'].map(UnitEconomicsUserRowToJSON)),
    };
}
